export const setProofBodyStorage = function(key, value) {
  localStorage.setItem(key, value);
}

export const getProofBodyStorage = function(age) {
  const value = localStorage.getItem(`proof-value-${age}`);
  return value == null ? 0 : value;
}

export const clearProofBodyStorage = function() {
  for (let index = localStorage.length - 1; index >= 0; index--) {
    const key = localStorage.key(index);
    if (key && key.startsWith('proof-value-')) localStorage.removeItem(key);
  }
}
